import { useEffect } from 'react';
import './App.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import LandingPage from './pages/LandingPage';
import "@fontsource/eb-garamond";
import ScrollToTopBtn from './components/ui/ScrollToTopBtn';
import AutoScrollToTop from './lib/scrolling/AutoScrollToTop';
import CallButton from './components/ui/CallButton';
import { useNavbarHeight } from './utils/contexts/NavbarContext';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToHashOnLoad from './lib/scrolling/ScrollToHashOnLoad';
import HelmetJsonLd from './seo/HelmetJsonLd';

function App() {

  const { navbarHeight, setNavbarHeight } = useNavbarHeight();

  useEffect(() => {

    const navbar = document.querySelector(".navbar") as HTMLElement | null;

    if (!navbar)     
      return;

    const updatePadding = () => {
      const height = navbar.offsetHeight;
      document.body.style.paddingTop = `${height}px`;
      setNavbarHeight(height);
    };

    updatePadding();
    window.addEventListener("resize", updatePadding);

    return () => {
      window.removeEventListener("resize", updatePadding);
    };

  }, [setNavbarHeight]);
  
  return (
    <Router>
      
      {/* HelmetProvider to manage document head */}
      <HelmetProvider>

        {/* Inject JSON-LD structured data */}
        <HelmetJsonLd />
      </HelmetProvider>

      <Navbar />

      <ScrollToTopBtn />
      <AutoScrollToTop />
      <CallButton />

      {/* Define application routes */}
      <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/unauthorized" element={<h1>You're not authorized to visit this page.</h1>} />
          <Route path="*" element={<><h1>Oops!</h1><p>The page you were looking for does not exist :(</p></>} />
      </Routes>

      {/* Scroll to hash on load with offset for navbar height */}
      <ScrollToHashOnLoad offset={navbarHeight} />
    </Router>
  );
}

export default App;
